import React, { useEffect, useRef, useState } from 'react'
import { Travel } from '../TravelsPlanned/model'
import './SingleTravel.min.css'
import { AiFillEdit, AiFillDelete, AiOutlineAppstoreAdd, AiOutlineClose, AiOutlineArrowDown } from 'react-icons/ai'
import { MdDone } from 'react-icons/md'
import { IoMdAddCircle } from 'react-icons/io'
import Swal from 'sweetalert2'
import CostsTravel from './CostsTravel'
import ShoppingTravel from './ShoppingTravel'
import BaggagesTravel from './BaggagesTravel'
import AttractionsTravel from './AttractionsTravel'
import GroupAttractionsTravel from './GroupAttractionsTravel'
import NotesTravel from './NotesTravel'
import axios from "axios";
import { ipAddress } from '../../ipAddress'



interface Props {
  travel: Travel; // Travel z wielkiej litery zawiera city, date i id.
  travels: Travel[];
  setTravels: React.Dispatch<React.SetStateAction<Travel[]>>;

}

interface Cost {
  id: number;
  name: string;
  kwota: number;
  isDone: number;
}
interface Thing {
  id: number;
  name: string;
  isDone: number;
}
interface Baggages {
  id: number;
  name: string;
  isDone: number;
  description: string;
}

interface Attractions {
  id: number;
  name: string;
  isDone: number;
  description: string;
}
interface AttractionsGroups {
  id: number;
  name: string;
}
interface Notes {
  id: number;
  name: string;
  isDone: number;
}


const SingleTravel: React.FC<Props> = ({ travels, setTravels, travel }) => {


  const [edit, setEdit] = useState<boolean>(false);
  const [editCity, setEditCity] = useState<string>(travel.city);
  const [editDate, setEditDate] = useState<string>(travel.date);
  const [editDateEnd, setEditDateEnd] = useState<string>(travel.dateEnd);
  const [addOption, setAddOption] = useState<boolean>(false);
  const [cost, setCost] = useState<boolean>(false);
  const [shopping, setShopping] = useState<boolean>(false);
  const [bag, setBag] = useState<boolean>(false);
  const [attraction, setAttraction] = useState<boolean>(false);
  const [note, setNote] = useState<boolean>(false);
  const [costList, setCostList] = useState<boolean>(false);
  const [costList2, setCostList2] = useState<boolean>(false);
  const [costs, setCosts] = useState<Cost[]>([]);
  const [descriptionCost, setDescriptionCost] = useState<string>('');
  const [price, setPrice] = useState<string>('');
  const [resultCost, setResultCost] = useState([]);
  const [AllCostTravel, setAllCostTravel] = useState<number>(0);
  const [shoppingList, setShoppingList] = useState<boolean>(false);
  const [shoppingList2, setShoppingList2] = useState<boolean>(false);
  const [descriptionShopping, setDescriptionShopping] = useState<string>('');
  const [things, setThings] = useState<Thing[]>([]);
  const [baggagesList, setBaggagesList] = useState<boolean>(false);
  const [baggagesList2, setBaggagesList2] = useState<boolean>(false);
  const [descriptionBaggages, setDescriptionBaggages] = useState<string>('');
  const [baggages, setBaggages] = useState<Baggages[]>([]);
  const [attractions, setAttractions] = useState<Attractions[]>([]);
  const [attractionsGroups, setAttractionsGroups] = useState<AttractionsGroups[]>([]);
  const [attractionsListGroup, setAttractionsListGroup] = useState<boolean>(false);
  const [attractionsList, setAttractionsList] = useState<boolean>(false);
  const [attractionsList2, setAttractionsList2] = useState<boolean>(false);
  const [attractionsListGroup2, setAttractionsListGroup2] = useState<boolean>(false);
  const [nameAttraction, setNameAttraction] = useState<string>('');
  const [nameAttractionGroup, setNameAttractionGroup] = useState<string>('');
  const [notes, setNotes] = useState<Notes[]>([]);
  const [notesList, setNotesList] = useState<boolean>(false);
  const [notesList2, setNotesList2] = useState<boolean>(false);
  const [descriptionNotes, setDescriptionNotes] = useState<string>('');
  const [addDefaultListBaggages, setAddDefaultListBaggages] = useState<boolean>(false);
  const [visibleView, setVisibleView] = useState<boolean>(false);
  const [updateGroups, setUpdateGroups] = useState<boolean>(false)
  const [updateCity, setUpdateCity] = useState<boolean>(false)
  const [days, setDays] = useState<number>(0);

  async function getCities() {
    console.log("pobieram")
    await axios.get(ipAddress + "/getcities")
      .then((response) => {
        setTravels(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")

      })
    setUpdateCity(false)

  }

  useEffect(() => {
    getCities();
  }, [updateCity])


  const handleDelete = (id: number) => {

    setAddOption(false)
    Swal.fire({
      title: 'Czy jesteś pewien?',
      text: "Element zostanie na zawsze usunięty!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + "/deletecity", {
          id: id,

        })
        /*setTravels(travels.filter((travel) => (travel.id !== id)))*/
        axios.post(ipAddress + "/deleteTravelCostsAll", {

          cityId: id,
        })
        axios.post(ipAddress + "/deleteThingsToBuyAll", {
          cityId: id,
        })
        axios.post(ipAddress + "/deleteEquipmentAll", {

          cityId: id,
        })
        axios.post(ipAddress + "/deleteAttractionsAll", {

          cityId: id,
        })
        axios.post(ipAddress + "/deleteAttractionsGroupsAll", {

          cityId: id,
        })
        axios.post(ipAddress + "/deleteNotesAll", {

          cityId: id,
        })
      }
      setUpdateCity(true)
    })

  }



  const handleDone = (id: number) => {
    setAddOption(false)
    Swal.fire({
      title: 'Czy jesteś pewien?',
      text: "Element zostanie przeniesiony do zakończonych",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, move it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + "/donecity", {
          id: id,
          isDone: 1,

        })
      }
    })

      .then((response) => {
        /*setTravels(travels.map((travel) => travel.id == id ? { ...travel, isDone: 1 } : travel)) */
      })

      .catch(function (error) {
        console.log("error!")

      })
    setUpdateCity(true)
  }




  const handleEdit = (e: React.FormEvent, id: number) => {
    setAddOption(false);
    e.preventDefault();
    axios.post(ipAddress + "/updatecity", {
      name: editCity,
      date: editDate,
      dateEnd: editDateEnd,
      id: id,

    })
      .then((response) => {
        /*  setTravels(travels.map((travel) => (
           travel.id === id ? {...travel, city:editCity , date: editDate } : travel
         ))) */
      })
      .catch(function (error) {
        console.log("error!")

      })

    setEdit(false)
    setUpdateCity(true)
  }

  const close = () => {
    setEdit(false);

  }

  const handleAdd = () => {
    setAddOption(true)

  }


  const handleAdd2 = (e: React.FormEvent, id: number) => {
    e.preventDefault();

    axios.post(ipAddress + '/addTravelCosts', {
      id: Math.random(),
      name: descriptionCost,
      kwota: price,
      isDone: 0,
      cityId: id,
    })
      .then((response) => {
        // setCosts([...costs, { id:id, name: descriptionCost, kwota: price, isDone: false }])
      })
      .catch((err) => {
        console.log(err)
      })


    setDescriptionCost('');
    setPrice('');
    setCostList(false);
    setCostList2(true);

  }
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef.current?.focus();

  }, [costList])


  const finishCost = () => {
    if (AllCostTravel == 0) {
      setResultCost(costs.map((cost) =>
        cost.isDone == 1 ? 0 : cost.kwota));

      let suma: number = 0;
      for (let i = 0; i < resultCost.length; i++) {
        suma += resultCost[i];
      }
      setAllCostTravel(suma)

      axios.post(ipAddress + "/getTravelCosts", {
        cityId: travel.id,
      })
        .then((response) => {
          setCosts(response.data)

        }
        )

        .catch(function (error) {
          console.log("error!")
        })
    }


  }


  useEffect(() => {
    if (visibleView == true) {
      if (costs.length > 0) {
        finishCost();
      }
    }


  }, [costs])

  async function updateCosts() {
    await axios.post(ipAddress + "/getTravelCosts", {
      cityId: travel.id,
    })
      .then((response) => {
        setCosts(response.data)

      }
      )

      .catch(function (error) {
        console.log("error!")
      })
    finishCost2();
  }

  useEffect(() => {
    updateCosts()
  }, [costs])

  const finishCost2 = () => {

    setResultCost(costs.map((cost) =>
      cost.isDone == 1 ? 0 : cost.kwota));

    let suma: number = 0;
    for (let i = 0; i < resultCost.length; i++) {
      suma += resultCost[i];
    }
    setAllCostTravel(suma)


  }

  const handleAdd3 = (e: React.FormEvent, id: number) => {
    e.preventDefault();

    axios.post(ipAddress + '/addTravelThings', {
      id: Math.random(),
      name: descriptionShopping,
      isDone: 0,
      cityId: id,
    })
      .then((response) => {
        // setThings([...things, { id: Math.random(), name: descriptionShopping, isDone: 0 }])
      })
      .catch((err) => {
        console.log(err)
      })

    setDescriptionShopping('');
    setShoppingList(false);
    setShoppingList2(true);

  }

  const inputRef2 = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef2.current?.focus();


  }, [shoppingList])

  const updateTravelThings = () => {
    axios.post(ipAddress + "/getTravelThings", {
      cityId: travel.id,
    })
      .then((response) => {
        setThings(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })
  }

  useEffect(() => {
    updateTravelThings()
  }, [things])


  const handleAdd4 = (e: React.FormEvent, id: number) => {
    e.preventDefault();
    console.log("tak")
    axios.post(ipAddress + '/addTravelBaggages', {
      id: Math.random(),
      name: descriptionBaggages,
      isDone: 0,
      cityId: id,
      summerList: ''
    })
      .then((response) => {
        // setBaggages([...baggages, { id: Math.random(), name: descriptionBaggages, isDone: 0 }])
      })
      .catch((err) => {
        console.log(err)
      })

    setDescriptionBaggages('');
    setBaggagesList(false);
    setBaggagesList2(true);


  }
  const inputRef3 = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef3.current?.focus();

  }, [baggagesList])

  const updateTravelBaggages = () => {
    axios.post(ipAddress + "/getTravelBaggages", {
      cityId: travel.id,
    })
      .then((response) => {
        setBaggages(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })
  }

  useEffect(() => {
    updateTravelBaggages()
  }, [baggages])






  const handleAdd7 = (e: React.FormEvent, id: number) => {
    e.preventDefault();

    axios.post(ipAddress + '/addTravelAttractionsGroup', {
      id: Math.random(),
      name: nameAttractionGroup,
      isDone: 0,
      cityId: id,
      description: '',
    })
      .then((response) => {
        // setBaggages([...baggages, { id: Math.random(), name: descriptionBaggages, isDone: 0 }])
      })
      .catch((err) => {
        console.log(err)
      })

    setNameAttractionGroup('');
    setAttractionsListGroup(false);
    //setAttractionsList2(true);


  }
  const inputRef7 = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef7.current?.focus();

  }, [attractionsListGroup])




  const handleAdd6 = (e: React.FormEvent, id: number) => {
    e.preventDefault();

    axios.post(ipAddress + '/addTravelNotes', {
      id: Math.random(),
      name: descriptionNotes,
      isDone: 0,
      cityId: id,
    })
      .then((response) => {
        // setBaggages([...baggages, { id: Math.random(), name: descriptionBaggages, isDone: 0 }])
      })
      .catch((err) => {
        console.log(err)
      })

    setDescriptionNotes('');
    setNotesList(false);
    setNotesList2(true);


  }
  const inputRef5 = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef5.current?.focus();

  }, [notesList])

  const updateTravelNotes = () => {
    axios.post(ipAddress + "/getTravelNotes", {
      cityId: travel.id,
    })
      .then((response) => {
        setNotes(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })
  }

  useEffect(() => {
    updateTravelNotes()
  }, [notes])




  const visible = (id: number) => {
    setVisibleView(!visibleView);
    setCost(!cost);
    setCostList2(false)
    setShopping(!shopping);
    setBag(!bag);
    setShoppingList2(false);
    setBaggagesList2(false);
    setAttraction(!attraction);
    setAttractionsListGroup2(false);
    setNote(!note);
    setNotesList2(false);

    axios.post(ipAddress + "/getTravelCosts", {
      cityId: id,
    })
      .then((response) => {
        setCosts(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })


    axios.post(ipAddress + "/getTravelThings", {
      cityId: id,
    })
      .then((response) => {
        setThings(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })
    axios.post(ipAddress + "/getTravelBaggages", {
      cityId: id,
    })
      .then((response) => {
        setBaggages(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })

    axios.post(ipAddress + "/getTravelAttractionsGroup", {
      cityId: id,
    })
      .then((response) => {
        setAttractionsGroups(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })

    axios.post(ipAddress + "/getTravelNotes", {
      cityId: id,
    })
      .then((response) => {
        setNotes(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })


  }
  const resize = () => {
    let element = document.getElementById("textAreaCost")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }
  const resize2 = () => {
    let element = document.getElementById("textAreaShopping")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }
  const resize3 = () => {
    let element = document.getElementById("textAreaBaggage")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }
  const resize4 = () => {
    let element = document.getElementById("textAreaAttraction")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }
  const resize5 = () => {
    let element = document.getElementById("textAreaNote")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }

  const closeAddCost = () => {
    setCostList(false);
    setDescriptionCost('');
  }
  const closeAddShopping = () => {
    setShoppingList(false)
    setDescriptionShopping('');
  }
  const closeAddBaggage = () => {
    setBaggagesList(false);
    setDescriptionBaggages('');
  }
  const closeAddAttraction = () => {
    setAttractionsList(false);
    setNameAttraction('');
  }
  const closeAddAttractionGroup = () => {
    setAttractionsListGroup(false);
    setNameAttractionGroup('');

  }

  const closeAddNote = () => {
    setNotesList(false);
    setDescriptionNotes('');
  }
  let defaultBaggagesList = [];
  defaultBaggagesList.push(
    { name: 'Waciki + patyczki do uszu ' },
    { name: 'Spryskiwacz z wodą' },
    { name: 'Mokre chusteczki ' },
    { name: 'Krem z filtrem 50' },
    { name: 'Czapka na słońce' },
    { name: 'Ciuchy letnie i ciepłe' },
    { name: 'Namiot na plażę' },
    { name: 'Koło do wody' },
    { name: 'Kaszka+ musy' },
    { name: 'Pojemnik na owoce' },
    { name: 'Książeczka zdrowia+ karty EKUZ' },
    { name: 'Leki: na biegunkę, na zęby, przeciwgorączkowe, na rany, plastry' },
    { name: 'Witamina D, sól fizjologiczna' },
    { name: 'Termometr' },
    { name: 'Mydełko na plamy' },
    { name: 'Kostium kąpielowy' },
    { name: 'Pamoerdy do wody 8 szt, pampersy 8 szt na drogę, podkłady 3szt' },
    { name: 'Termos+ mleko MM' },
    { name: 'Prowiant na drogę' },


  )

  const defaultListBaggages = (e: React.FormEvent, id: number) => {
    e.preventDefault()
    for (let i = 0; i < defaultBaggagesList.length; i++) {
      axios.post(ipAddress + '/addTravelBaggages', {
        id: Math.random(),
        name: defaultBaggagesList[i].name,
        isDone: 0,
        cityId: id,
        summerList: 'yes',
      })
        .then((response) => {
          // setBaggages([...baggages, { id: Math.random(), name: descriptionBaggages, isDone: 0 }])
        })
        .catch((err) => {
          console.log(err)
        })
    }
    setAddDefaultListBaggages(false)
  }

  const deleteDefaultListBaggages = (e: React.FormEvent, id: number) => {
    e.preventDefault();
    axios.post(ipAddress + "/deleteEquipmentSummerList", {
      cityId: id,
      summerList: 'yes'
    })

    setAddDefaultListBaggages(false)
  }

  const updateTravelAttractionsGroups = () => {
    axios.post(ipAddress + "/getTravelAttractionsGroup", {
      cityId: travel.id,
    })
      .then((response) => {
        setAttractionsGroups(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })

  }

  useEffect(() => {
    updateTravelAttractionsGroups()


  }, [attractionsGroups])


  let countDown = () => {
    let startTravel = new Date(travel.date);
    let currentDate = new Date();
    let timeDiff = startTravel.getTime() - currentDate.getTime();

    setDays(Math.round(timeDiff / (1000 * 3600 * 24)));
    //Jak dołożymy godzinę wyjazdu to można dodać ile godzin, minut i sekund pozostało.
    let hours;

  }
  useEffect(() => {
    countDown();


  }, [])


  return (

    <div className='singleTravelAll'>
      <div className='singleTravel'>
        {edit ? (
          <form className='editTravels' onSubmit={(e) => { handleEdit(e, travel.id) }}>
            <span className='icon' id='close' onClick={() => close()} ><AiOutlineClose /></span>
            <p>Edytuj wyjazd</p>
            <div className='city'>
              <label htmlFor="city">Gdzie: </label>
              <input type="input"
                id='city'
                value={editCity}
                onChange={(e) => setEditCity(e.target.value)}
              ></input>
            </div>
            <div className='date'>
              <label htmlFor="date">Kiedy: </label>
              <input type='date'
                value={editDate}
                id='editDate'
                onChange={(e) => setEditDate(e.target.value)}
              ></input>
              <input type='date'
                value={editDateEnd}
                id='editDateEnd'
                onChange={(e) => setEditDateEnd(e.target.value)}
              ></input>
            </div>
            <button type='submit'>OK</button>
          </form>
        ) : (<div></div>)
        }
        {travel.dateEnd.length == 0 ?
          (<div>
            <p className='text' onClick={() => (visible(travel.id))}>{travel.city} {travel.date}</p>
            {days > 0 ?
              (
                <p className='text'> Pozostało: {days} dni </p>
              ) : (<div></div>)

            }
          </div>)
          :
          (
            <div>
              <p className='text' onClick={() => (visible(travel.id))}>{travel.city} {travel.date} : {travel.dateEnd}</p>
              {days > 0 ?
              (
                <p className='text'> Pozostało: {days} dni </p>
              ) : (<div></div>)

            }
            </div>)}






        {/* <span className='icon' onClick={() => {
          if (!edit && !travel.isDone) (
            setEdit(true)
          )
        }} ><AiFillEdit /></span>
        <span className='icon' onClick={() => handleDone(travel.id)} ><MdDone /></span>
        <span className='icon' onClick={() => handleDelete(travel.id)} ><AiFillDelete /></span> */}
        <span className='icon' onClick={() => handleAdd()} ><AiOutlineAppstoreAdd /></span>

        {addOption ? (
          <div className='addOption'>
            <p>{travel.city}</p>
            <p onClick={() => {
              if (!edit && !travel.isDone) (
                setEdit(true)
              )
              setAddOption(false)
            }}><AiFillEdit /><span>Edytuj</span></p>
            {/* <p onClick={() => handleDone(travel.id)} ><MdDone /><span>Zakończ</span></p> */}

            <p onClick={() => handleDelete(travel.id)} ><AiFillDelete /><span>Usuń</span></p>
            <button onClick={() => setAddOption(false)}>Cancel</button>
          </div>

        ) : (
          <div></div>
        )
        }
      </div>
      {cost ? (
        <div id='cost'>
          {costs.length > 0 ? (
            <p><span onClick={() => setCostList2(!costList2)}>Koszt wyjazdu:  {AllCostTravel} zł  <span className='icon'><AiOutlineArrowDown /></span></span><span className='add' onClick={() => setCostList(true)}><IoMdAddCircle /></span></p>
          ) : (
            <p><span onClick={() => setCostList2(!costList2)}>Koszt wyjazdu:  {AllCostTravel} zł  </span><span className='add' onClick={() => setCostList(true)}><IoMdAddCircle /></span></p>
          )
          }
          {costList ?
            (<div className='addCost'>
              <form onSubmit={(e) => { handleAdd2(e, travel.id) }}>
                <button type='button' id='close' onClick={() => closeAddCost()} >X</button>
                <p id='city'>{travel.city}</p>
                <p>Dodaj koszt wyjazdu</p>

                <div className='thingName'>

                  <textarea id='textAreaCost'
                    rows={1}
                    placeholder='Czego dotyczy koszt ?'
                    value={descriptionCost}
                    onChange={(e) => (resize(), setDescriptionCost(e.target.value))}
                    required
                  ></textarea>
                </div>

                <div className='thingCost'>
                  <label htmlFor="cost" >Kwota:</label>
                  <input type="number"
                    placeholder='PLN'
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    required
                  ></input>
                </div>
                <button type='submit' id='submit'>OK</button>

              </form>
            </div>
            ) : (
              <div></div>
            )
          }
          {costList2 ? (
            <div>
              {costs.map((money) => (
                <CostsTravel costs={costs} setCosts={setCosts} money={money}
                  key={money.id} travel={travel} />
              ))
              }
            </div>
          ) : (
            <div></div>
          )
          }
        </div>
      ) : (
        <div></div>
      )
      }

      {shopping ? (
        <div id='shopping'>

          {
            things.length > 0 ? (
              <p><span onClick={() => setShoppingList2(!shoppingList2)}>Zakupy <span className='icon'><AiOutlineArrowDown /></span></span><span className='add' onClick={() => setShoppingList(true)}><IoMdAddCircle /></span></p>
            ) :
              (
                <p><span onClick={() => setShoppingList2(!shoppingList2)}>Zakupy</span><span className='add' onClick={() => setShoppingList(true)}><IoMdAddCircle /></span></p>
              )
          }

          {shoppingList ? (
            <div className='addShopping'>

              <form onSubmit={(e) => { handleAdd3(e, travel.id) }}>
                <button type='button' id='close' onClick={() => closeAddShopping()}>X</button>
                <p id='city'>{travel.city}</p>
                <p>Dodaj rzecz do kupienia</p>
                <div className='thingName'>
                  <textarea id='textAreaShopping'
                    rows={1}
                    placeholder='Co kupić ?'
                    value={descriptionShopping}
                    onChange={(e) => (resize2(), setDescriptionShopping(e.target.value))}
                    required
                  ></textarea>
                </div>
                <button type='submit' id='submit'>OK</button>

              </form>
            </div>
          ) : (
            <div></div>
          )
          }
          {shoppingList2 ? (
            <div>

              {things.map((thing) => (
                <ShoppingTravel things={things} setThings={setThings}
                  thing={thing} key={thing.id} travel={travel} />
              ))}
            </div>
          ) : (
            <div></div>
          )
          }
        </div>
      ) : (
        <div></div>
      )
      }
      {bag ? (
        <div id='bag'>
          {baggages.length > 0 ? (
            <p><span onClick={() => setBaggagesList2(!baggagesList2)}>Do spakowania <span className='icon'><AiOutlineArrowDown /></span></span><span className='addDefaultListBaggages' onClick={() => setAddDefaultListBaggages(true)}><AiOutlineAppstoreAdd /></span><span className='add' onClick={() => setBaggagesList(true)}><IoMdAddCircle /></span></p>
          ) :
            (
              <p><span onClick={() => setBaggagesList2(!baggagesList2)}>Do spakowania </span><span className='addDefaultListBaggages' onClick={() => setAddDefaultListBaggages(true)}><AiOutlineAppstoreAdd /></span><span className='add' onClick={() => setBaggagesList(true)}><IoMdAddCircle /></span></p>
            )
          }
          {addDefaultListBaggages ?
            (<div className='addDefaultList'>
              <p>{travel.city}</p>
              <p>Lista podstawowa</p>
              <button className='add' onClick={(e) => defaultListBaggages(e, travel.id)}>Dodaj</button>
              <button className='delete' onClick={(e) => deleteDefaultListBaggages(e, travel.id)}>Usuń</button>
              <button className='cancel' onClick={() => setAddDefaultListBaggages(false)}>Cancel</button>
            </div>
            )
            :
            (<div></div>)}
          {baggagesList ? (
            <div className='addBaggage'>
              <form onSubmit={(e) => { handleAdd4(e, travel.id) }}>
                <button type='button' id='close' onClick={() => closeAddBaggage()} >X</button>
                <p id='city'>{travel.city}</p>
                <p>Dodaj rzecz do spakowania</p>
                <div className='thingName'>

                  <textarea id='textAreaBaggage'
                    rows={1}
                    placeholder='Co spakować ?'
                    value={descriptionBaggages}
                    onChange={(e) => (resize3(), setDescriptionBaggages(e.target.value))}
                    required
                  ></textarea>
                </div>
                <button type='submit' id='submit'>OK</button>

              </form>
            </div>

          ) : (
            <div></div>
          )

          }
          {baggagesList2 ? (

            <div>

              {baggages.map((baggage) => (
                <BaggagesTravel baggages={baggages} setBaggages={setBaggages}
                  baggage={baggage} key={baggage.id} travel={travel} />
              ))}
            </div>
          ) : (
            <div></div>
          )
          }

        </div>

      ) : (
        <div></div>
      )

      }
      {attraction ? (
        <div id='attraction'>
          {attractionsGroups.length > 0 ? (
            <p><span onClick={() => setAttractionsListGroup2(!attractionsListGroup2)}>Atrakcje <span className='icon'><AiOutlineArrowDown /></span></span><span className='addGroup' onClick={() => setAttractionsListGroup(true)}><IoMdAddCircle /></span></p>
          ) :
            (
              <p><span onClick={() => setAttractionsListGroup2(!attractionsListGroup2)}>Atrakcje </span><span className='addGroup' onClick={() => setAttractionsListGroup(true)}><IoMdAddCircle /></span></p>

            )
          }
          {attractionsListGroup ? (
            <div className='addAttractionGroup'>
              <form onSubmit={(e) => { handleAdd7(e, travel.id) }}>
                <button type='button' id='close' onClick={() => closeAddAttractionGroup()} >X</button>
                <p id='city'>{travel.city}</p>
                <p>Dodaj miejscowość którą chcesz zwiedzić:</p>
                <div className='thingName'>

                  <textarea id='textAreaAttraction'
                    rows={1}
                    value={nameAttractionGroup}
                    onChange={(e) => setNameAttractionGroup(e.target.value)}
                    required
                  ></textarea>
                </div>
                <button type='submit' id='submit'>OK</button>

              </form>
            </div>

          ) : (
            <div></div>
          )

          }


          {attractionsListGroup2 ? (
            <div>
              {attractionsGroups.map((group) => (
                <GroupAttractionsTravel group={group} key={group.id} travel={travel} />
              ))}
            </div>
          ) : (
            <div></div>
          )
          }


        </div>

      ) : (
        <div></div>
      )
      }

      {note ? (
        <div id='note'>
          {notes.length > 0 ? (
            <p><span onClick={() => setNotesList2(!notesList2)}>Notatki <span className='icon'><AiOutlineArrowDown /></span></span><span className='add' onClick={() => setNotesList(true)}><IoMdAddCircle /></span></p>
          ) :
            (
              <p><span onClick={() => setNotesList2(!notesList2)}>Notatki </span><span className='add' onClick={() => setNotesList(true)}><IoMdAddCircle /></span></p>
            )
          }
          {notesList ? (
            <div className='addNote'>
              <form onSubmit={(e) => { handleAdd6(e, travel.id) }}>
                <button type='button' id='close' onClick={() => closeAddNote()} >X</button>
                <p id='city'>{travel.city}</p>
                <p>Dodaj notatke</p>
                <div className='thingName'>

                  <textarea id='textAreaNote'
                    rows={1}
                    placeholder='Napisz notatke ?'
                    value={descriptionNotes}
                    onChange={(e) => (resize5(), setDescriptionNotes(e.target.value))}
                    required
                  ></textarea>
                </div>
                <button type='submit' id='submit'>OK</button>

              </form>
            </div>

          ) : (
            <div></div>
          )

          }
          {notesList2 ? (

            <div>

              {notes.map((note) => (
                <NotesTravel notes={notes} setNotes={setNotes}
                  note={note} key={note.id} travel={travel} />
              ))}
            </div>
          ) : (
            <div></div>
          )
          }
        </div>

      ) : (
        <div></div>
      )
      }

    </div>


  )

}

export default SingleTravel;